<template>
  <div>
    <hr>

    <tag-select
      v-model="tags"
      :label="$t('c.searchFilterForm.form.label.tags')"
      :tags="tagsOptions"
      name="tags"
      direction="vertical"
    />

    <hr>

    <div class="row">
      <div class="col-md-6">
        <text-input
          v-model="createdAtFrom"
          :label="$t('c.searchFilterForm.form.label.createdAtFrom')"
          :placeholder="$t('c.searchFilterForm.form.placeholder.publishedAtUntil')"
          name="createdAtFrom"
          direction="vertical"
          type="date"
        />
      </div>
      <div class="col-md-6">
        <text-input
          v-model="createdAtUntil"
          :label="$t('c.searchFilterForm.form.label.createdAtUntil')"
          :placeholder="$t('c.searchFilterForm.form.placeholder.createdAtUntil')"
          name="createdAtUntil"
          direction="vertical"
          type="date"
        />
      </div>
    </div>


    <div class="row">
      <div class="col-md-6">
        <text-input
          v-model="publishedAtFrom"
          :label="$t('c.searchFilterForm.form.label.publishedAtFrom')"
          :placeholder="$t('c.searchFilterForm.form.placeholder.publishedAtFrom')"
          name="publishedAtFrom"
          direction="vertical"
          type="date"
        />
      </div>
      <div class="col-md-6">
        <text-input
          v-model="publishedAtUntil"
          :label="$t('c.searchFilterForm.form.label.publishedAtUntil')"
          :placeholder="$t('c.searchFilterForm.form.placeholder.publishedAtUntil')"
          name="publishedAtUntil"
          direction="vertical"
          type="date"
        />
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-md-6">
        <text-input
          v-model="sourceName"
          :label="$t('c.searchFilterForm.form.label.source')"
          name="sourceName"
          direction="vertical"
        />

        <select-input
          v-model="priority"
          :label="$t('c.searchFilterForm.form.label.priority')"
          :options="priorityOptions"
          :empty-label="null"
          name="priority"
          direction="vertical"
        />
      </div>
      <div class="col-md-6">
        <tags-input
          v-model="countries"
          :label="$t('c.searchFilterForm.form.label.countries')"
          :label-visible="true"
          :options="countriesOptions"
          name="countries"
          direction="vertical"
        />
      </div>
    </div>

    <div class="content-modal__form-actions">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.searchFilterForm.form.action.submit'"
              class="content-modal__publish-button"
              type="submit"
              @click="handleSubmit"
            />
          </div>
          <div class="col-xs-6 col-lg-4 push-lg-2 text-right">
            <button-input
              v-t="'c.searchFilterForm.form.action.cancel'"
              class="content-modal__cancel-button"
              color="grey"
              @click="closeOverlay"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FormMixin from '@/mixins/forms/Form'

export default {
  name: 'ContentFilterForm',
  mixins: [
    FormMixin
  ],
  data () {
    return {
      tags: [],
      countries: [],
      sourceName: '',
      createdAtFrom: '',
      createdAtUntil: '',
      publishedAtFrom: '',
      publishedAtUntil: '',
      priority: ''
    }
  },
  computed: {
    ...mapState({
      filter: state => state.contentFilter.filter,
    }),
    ...mapGetters({
      filterIsActive: 'contentFilter/filterIsActive',
      priorityOptions: 'contentFilter/priorityOptions',
      countriesOptions: 'countriesOptions',
      tagsOptions: 'tagsOptions',
    })
  },
  methods: {
    ...mapActions({
      resetContentFilter: 'contentFilter/reset'
    }),
    ...mapActions({
      loadingStart: 'app/loadingStart',
      loadingDone: 'app/loadingDone',
      fetchTags: 'fetchTags',
      fetchCountries: 'fetchCountries',
      fetchContents: 'contents/fetch',
      setContents: 'contents/apply',
      closeOverlay: 'closeOverlay'
    }),
    handleSubmit () {
      this.$store.dispatch('contentFilter/setTags', this.tags)
      this.$store.dispatch('contentFilter/setCountries', this.countries)
      this.$store.dispatch('contentFilter/setSourceName', this.sourceName)
      this.$store.dispatch('contentFilter/setCreatedAtFrom', this.createdAtFrom)
      this.$store.dispatch('contentFilter/setCreatedAtUntil', this.createdAtUntil)
      this.$store.dispatch('contentFilter/setPublishedAtFrom', this.publishedAtFrom)
      this.$store.dispatch('contentFilter/setPublishedAtUntil', this.publishedAtUntil)
      this.$store.dispatch('contentFilter/setPriority', this.priority)

      this.loadingStart()
      this.fetchContents()
        .then((response) => {
          this.setContents(response)
          this.closeOverlay()
          this.loadingDone()
        })
    }
  },
  created () {
    this.tags = this.$store.state.contentFilter.filter.tags
    this.countries = this.$store.state.contentFilter.filter.countries
    this.sourceName = this.$store.state.contentFilter.filter.sourceName
    this.createdAtFrom = this.$store.state.contentFilter.filter.createdAtFrom
    this.createdAtUntil = this.$store.state.contentFilter.filter.createdAtUntil
    this.publishedAtFrom = this.$store.state.contentFilter.filter.publishedAtFrom
    this.publishedAtUntil = this.$store.state.contentFilter.filter.publishedAtUntil
    this.priority = this.$store.state.contentFilter.filter.priority

    this.$store.dispatch('fetchTags')
    this.$store.dispatch('fetchCountries')
  }
}
</script>




// WEBPACK FOOTER //
// src/components/search/SearchFilterForm.vue